export default __webpack_public_path__ + "static/media/Princeton.dd85a311.jpeg";